/**
 * Guard against out-of-order async responses: `apply` runs only for the value
 * of the LATEST tracked promise. Views that are reused across entities (e.g.
 * BuildingView switching buildings) fetch on every switch, and a slow response
 * for the previous entity must not clobber the current one's state when it
 * resolves last. Rejections are ignored — callers pass promises that already
 * degrade to a fallback value (or handle errors themselves).
 */
export const onlyLatest = <T>() => {
  let requestId = 0;
  return (promise: Promise<T>, apply: (value: T) => void): void => {
    requestId += 1;
    const id = requestId;
    promise.then((value) => {
      if (id === requestId) apply(value);
    });
  };
};
